module.exports = __webpack_public_path__ + "static/media/marked-for-review-and-answered.e68caeb0.svg";